module.exports = __webpack_public_path__ + "img/4.258863a0.jpg";